function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Grid, Heading, VerifiedByIelts, _LoadingIcon, WarningMessageBox } from "./style";

// eslint-disable-next-line react/display-name
var Contents = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var all_good = _ref.all_good,
    canSubmit = _ref.canSubmit,
    form = _ref.form,
    formLoading = _ref.formLoading,
    ielts_check = _ref.ielts_check,
    ielts_report = _ref.ielts_report,
    image = _ref.image,
    loading = _ref.loading,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    onSubmit = _ref.onSubmit,
    personal_check = _ref.personal_check,
    expiredExam = _ref.expiredExam,
    footerVerificationMessage = _ref.footerVerificationMessage;
  return formLoading ? /*#__PURE__*/React.createElement(_LoadingIcon, null, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "circle-o-notch",
    spin: true
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, "Official IELTS Report"), ielts_report && ielts_report.trf_image_data && /*#__PURE__*/React.createElement("img", {
    src: ielts_report.trf_image_data,
    alt: "TRF"
  }), /*#__PURE__*/React.createElement("div", {
    className: "input-row"
  }, /*#__PURE__*/React.createElement("input", {
    ref: ref,
    type: "text",
    placeholder: "IELTS TRF Number",
    name: "reference_code",
    onChange: onChange,
    onKeyDown: onKeyDown,
    value: form.reference_code || ''
  }), /*#__PURE__*/React.createElement("button", {
    onClick: onSubmit,
    disabled: !canSubmit
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: loading ? 'circle-o-notch' : 'search',
    spin: loading
  }), " Search")), /*#__PURE__*/React.createElement("div", {
    css: "flex: 0 0 100%; text-align: center"
  }, image && /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: "Profile"
  })), form.reference_code && form.reference_code.endsWith('G') && /*#__PURE__*/React.createElement(WarningMessageBox, null, "IELTS is General"), expiredExam && /*#__PURE__*/React.createElement(WarningMessageBox, null, "Exam date is over 2 years ago"), Object.keys(ielts_check).length > 0 && /*#__PURE__*/React.createElement(Grid, null, Object.keys(personal_check).map(function (key) {
    return _objectSpread(_objectSpread({}, personal_check[key]), {}, {
      key: key
    });
  }).map(function (_ref2) {
    var key = _ref2.key,
      label = _ref2.label,
      value = _ref2.value,
      message = _ref2.message,
      color = _ref2.color;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "ielts-".concat(key)
    }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement("span", {
      style: {
        color: color
      },
      "data-tip": message
    }, value));
  }), /*#__PURE__*/React.createElement(Heading, null, "Test Results"), /*#__PURE__*/React.createElement("span", null), Object.keys(ielts_check).map(function (key) {
    return _objectSpread(_objectSpread({}, ielts_check[key]), {}, {
      key: key
    });
  }).map(function (_ref3) {
    var key = _ref3.key,
      label = _ref3.label,
      value = _ref3.value,
      message = _ref3.message,
      color = _ref3.color;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "ielts-".concat(key)
    }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement("span", {
      style: {
        color: color
      },
      "data-tip": message
    }, value));
  })), all_good && /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement(VerifiedByIelts, null, /*#__PURE__*/React.createElement("span", {
    className: "badge-icon"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "check-circle-o"
  })), /*#__PURE__*/React.createElement("span", null, footerVerificationMessage))));
});
export default Contents;